import { Button } from "@chakra-ui/react";
import { useRequestParams } from "contexts/RequestParamsProvider";
import { CircledCloseIcon } from "icons";

const ResetAllFiltersButton = () => {
  const { isUsingInitialFilters, resetFilters } = useRequestParams();

  return (
    !isUsingInitialFilters && (
      <Button
        onClick={resetFilters}
        color="warningRed"
        display="inline-flex"
        fontSize="sm"
        fontWeight="semibold"
        leftIcon={<CircledCloseIcon boxSize={6} />}
        px={3}
        variant="unstyled"
        height={10}
      >
        Reset all
      </Button>
    )
  );
};

export default ResetAllFiltersButton;
